/* Copyright (c) 2026 Xperi. All Rights Reserved. */

/**
 * Feature Activation Framework — public barrel.
 *
 * `FeatureActivation` (the implementation) lives in `src/model/infrastructure`;
 * this module exposes the framework's pure metadata, types and resolvers.
 */

export {
  Feature,
  FeatureStage,
  FeatureType,
  BuildEnvironment,
  FeatureServiceSource,
  OVERRIDABLE_FEATURE_STAGES,
  isOverridableFeatureStage
} from "./types";
export type {
  TFeatureDefinition,
  TClientOnlyFeatureDefinition,
  TServiceControlledFeatureDefinition,
  TServiceFeatureMapping
} from "./types";
export { featureRegistry, registeredFeatures } from "./registry";
export { resolveStageVisibility } from "./StageVisibilityResolver";
export { resolveEffectiveStage } from "./EffectiveStageResolver";
export { resolveBuildEnvironment } from "./BuildEnvironment";
export { ServiceControlledFeatureResolver } from "./ServiceControlledFeatureResolver";
export {
  ServiceControlledFeatureState,
  SERVICE_CONTROLLED_STATE_STORAGE_KEY
} from "./ServiceControlledFeatureState";
